export default __webpack_public_path__ + "static/media/reminderIcon.27aac6c2.svg";